import React, { useRef, useState } from 'react'
import { Box, Text, Avatar, Icon } from 'elements'
import { useAuth, useOutsideClick } from 'hooks'
import { getUserName } from 'utils/user'
import UserMenu from './UserMenu'

export default function AvatarDropdown(props) {
  const { user, currentOrg } = useAuth()
  const [isOpen, setIsOpen] = useState(false)

  const ref = useRef()
  useOutsideClick(ref, () => setIsOpen(false))

  if (!user) {
    return null
  }

  const username = getUserName(user)

  return (
    <Box
      display="flex"
      ref={ref}
      alignItems="center"
      position="relative"
      onClick={() => setIsOpen(!isOpen)}
    >
      {currentOrg ? (
        <Text fontWeight="bold" mr="large">
          {currentOrg.name}
        </Text>
      ) : null}
      <Avatar name={username} mr="medium" />
      <Icon color="neutral.0" name="angle-down" size="small" />
      {isOpen ? (
        <Box position="absolute" top="100%" right="0" mt="5px">
          <UserMenu />
        </Box>
      ) : null}
    </Box>
  )
}
